export default __webpack_public_path__ + "static/media/04-Anghami.902dc13b.png";